import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Cart0 = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M2.5 1.25a1.25 1.25 0 1 0 0 2.5h1.982l1.366 8.939a1.25 1.25 0 0 0 1.235 1.061h9.226a1.25 1.25 0 0 0 1.205-.914l2.44-8.75a1.25 1.25 0 1 0-2.408-.672l-2.185 7.836H8.157L6.79 2.311A1.25 1.25 0 0 0 5.556 1.25zM10 16.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0m7.5 0a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0" }) }));
});
Cart0.displayName = 'Cart0';
Cart0.__iconComponentType = 'standard';
export default Cart0;
//# sourceMappingURL=Cart0.js.map